
import { get, map } from 'lodash';
import { connect } from 'react-redux';
import { getAvailableDates } from '../../Helpers';
import { setBookingStep, setCart, setDataByStep } from '../../Actions';
import { defaultErrorMessage } from '../../Assets/constants';


function LocationSelect(props) {
    const selectLocation = (location) => {
        const { setDataByStep, setBookingStep, setAlert } = props;
        setDataByStep(1, { ...props[1], location });
        getAvailableDates(location.id, (response) => {
            let { available_dates, data, email_required, payment_required } = response.data;
            if (!available_dates || available_dates.length === 0) {
                setAlert("error", "No available dates for this location");
                return;
            }
            setDataByStep(2, {
                available_dates,
                data,
                email_required,
                payment_required
            });
            setBookingStep(2);
        }, (err) => {
            console.log(err);
            setAlert("error", get(err, 'response.data.message', defaultErrorMessage));
        });
    }
    return (<>
        <div className='contentPrimary font-weight-bold size-44-52 sm-size-28-36 mb-16 sm-mb-8'>
            Select a location
        </div>
        <div className='size-18-28 sm-size-16-24 contentPrimary mb-32 sm-mb-40'>
            Where would you like to receive this service?
        </div>
        {map(get(props, "1.locations", []), (loc, it) => (<div key={`loc-${it}`} className='mb-16'>
            <button className='btn cta-tertiary' onClick={() => selectLocation(loc)}>
                {loc.name}
            </button>
        </div>))}
    </>);
}
const mapStateToProps = (state) => ({
    ...state.booking
});
export default connect(mapStateToProps, {
    setBookingStep, setDataByStep, setCart
})(LocationSelect);